import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faSearch,
  faPlus,
  faEllipsisH,
  faEye,
  faEdit,
  faTrashAlt,
} from "@fortawesome/free-solid-svg-icons";
import {
  Col,
  Row,
  Button,
  Form,
  InputGroup,
  Card,
  Dropdown,
  ButtonGroup,
  Badge,
  Nav,
  Pagination,
} from "@themesberg/react-bootstrap";
import { Link } from "react-router-dom";
import { Routes } from "../../routes";
import "../../scss/fcsvendor/layout/_vendor.scss";
import { getReminders, deleteReminder } from "../../app/api";
import axios from "axios";
import Loader from "../../components/Loader";
import swal from "sweetalert";
import moment from "moment";

export default () => {
  const [show, setShow] = useState(false);
  const [reminders, setReminder] = useState([]);
  const [totalPages, setTotalPages] = useState(0); // State to hold total pages
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(true);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const fetchReminders = async (currentPage) => {
    setLoading(true);
    try {
      const token = localStorage.getItem("token");
      const response = await axios.get(getReminders(), {
        headers: {
          "secret-key": process.env.REACT_APP_SECRET_KEY,
          "auth-token": `Bearer ${token}`,
        },
        params: {
          page: currentPage,
          search,
        },
      });
      // console.log(response.data);
      setReminder(response.data?.data);
      setTotalPages(response.data?.pagination?.total_pages);
    } catch (error) {
      // console.error("Error fetching vendors:", error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchReminders(page);
  }, [page, search]);
  const handleDelete = async (id) => {
    try {
      const token = localStorage.getItem("token");
      const response = await axios.delete(deleteReminder(id), {
        headers: {
          "secret-key": process.env.REACT_APP_SECRET_KEY,
          "auth-token": `Bearer ${token}`,
        },
      });
      // console.log(response.data);
      swal({
        text: response.data.message,
        icon: "success",
      });
    } catch (error) {
    swal({
            text: error.response.data.messages.error,
            icon: "error",
          });
    }
    fetchReminders(page);
  };
  return (
    <>
      <div>
        <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center mb-2">
          <div className="d-block  mb-md-0">
            <h4 className="mb-0">Reminders Management</h4>
          </div>
          <Col xs={12} md={4} lg={4} xl={4} className=" mb-sm-2">
            <Form.Group id="topbarSearch">
              <InputGroup className="input-group-merge search-bar">
                <InputGroup.Text>
                  <FontAwesomeIcon icon={faSearch} />
                </InputGroup.Text>
                <Form.Control
                  onChange={(e) => setSearch(e.target.value)}
                  type="text"
                  placeholder="Search"
                />
              </InputGroup>
            </Form.Group>
          </Col>
          <Button
            variant="primary"
            className=" me-2"
            as={Link}
            to={Routes.AddReminder.path}
          >
            <FontAwesomeIcon icon={faPlus} className="me-2" />
            <span>New</span>
          </Button>
        </div>
{/* 
        <Row md={12}>
          <Col md={4} className="mb-sm-4 mb-4">
            <Form.Group id="topbarSearch">
              <InputGroup className="input-group-merge search-bar">
                <InputGroup.Text>
                  <FontAwesomeIcon icon={faSearch} />
                </InputGroup.Text>
                <Form.Control
                  onChange={(e) => setSearch(e.target.value)}
                  type="text"
                  placeholder="Search"
                />
              </InputGroup>
            </Form.Group>
          </Col>
        </Row> */}
        {loading ? (
          <div style={{ display: "flex", justifyContent: "center" }}>
            <Loader />
          </div>
        ) : (
          <>
            <Row className="justify-content-md-center">
              <Col xs={12} sm={12} xl={12} lg={12} className="mb-4">
                <Row>
                  {reminders.map((reminders) => {
                    const dueDate = new Date(reminders.due_date);
                    const currentDate = new Date();

                    // Check if the due date is greater than or equal to the current date
                    const isDue = dueDate >= currentDate;
                    return (
                      <Col
                        key={reminders.id}
                        xs={12}
                        md={6}
                        lg={4}
                        className="mb-4"
                      >
                        <Card border="light" className="shadow-sm">
                          <div className="d-flex p-3  align-items-start">
                            <Card.Body className=" d-flex justify-content-center ">
                              <Row className=" d-flex  justify-content-center">
                                <Col xs={12} xl={12} className="px-xl-0">
                                  <div>
                                    <h3 className="mb-1 text-center">
                                      {reminders.vendor_name}
                                    </h3>
                                  </div>

                                  <h6 className="text-center">
                                    <Link
                                      className="Link_underline"
                                      to={`${Routes.ReminderDetail.path}/${reminders.id}`}
                                    >
                                      {reminders.title}{" "}
                                    </Link>
                                  </h6>
                                </Col>
                                <Col
                                  xl={2}
                                  xs={12}
                                  className="text-xl-center d-flex align-items-center justify-content-xl-center mb-3 mb-xl-0"
                                ></Col>
                              </Row>
                            </Card.Body>

                            <Dropdown as={ButtonGroup}>
                              <Dropdown.Toggle
                                as={Button}
                                split
                                variant="link"
                                className="text-dark m-0 p-0"
                              >
                                <span className="icon icon-sm">
                                  <FontAwesomeIcon
                                    icon={faEllipsisH}
                                    className="icon-dark"
                                  />
                                </span>
                              </Dropdown.Toggle>
                              <Dropdown.Menu>
                                <Dropdown.Item>
                                  <Link
                                    className="me-2"
                                    to={`${Routes.ReminderDetail.path}/${reminders.id}`}
                                  >
                                    <FontAwesomeIcon
                                      icon={faEye}
                                      className="me-2"
                                    />
                                    View Details
                                  </Link>
                                </Dropdown.Item>
                                <Dropdown.Item>
                                  <Link
                                    as={Link}
                                    to={`${Routes.AddReminder.path}/${reminders.id}`}
                                  >
                                    <FontAwesomeIcon
                                      icon={faEdit}
                                      className="me-2"
                                    />{" "}
                                    Edit
                                  </Link>
                                </Dropdown.Item>
                                <Dropdown.Item className="text-danger">
                                  <div
                                    onClick={() => handleDelete(reminders.id)}
                                  >
                                    <FontAwesomeIcon
                                      icon={faTrashAlt}
                                      className="me-2"
                                    />{" "}
                                    Remove
                                  </div>
                                </Dropdown.Item>
                              </Dropdown.Menu>
                            </Dropdown>
                          </div>
                          <small
                            className="d-flex justify-content-end mr-2"
                            style={{ marginRight: "10px" }}
                          >
                             Due Date: {moment(reminders.due_date).format("MM/DD/YYYY HH:mm")}
                          </small>
                          <div className="divider"></div>
                          <div className="d-flex justify-content-between p-3">
                            <Badge
                              pill
                              bg={isDue ? "primary" : "secondary"}
                              style={{
                                padding: "0.4rem 1rem",
                                fontSize: "0.85rem",
                                border: "1px solid #ddd",
                              }}
                            >
                              {isDue ? "Due" : "Past"}
                            </Badge>
                            <Badge
                              pill
                              bg="success"
                              style={{
                                padding: "0.4rem 1rem",
                                fontSize: "0.85rem",
                                border: "1px solid #ddd",
                              }}
                            >
                              {reminders?.email_reminder} Reminders
                            </Badge>
                          </div>
                        </Card>
                      </Col>
                    );
                  })}
                </Row>
              </Col>
            </Row>
            <Nav className="justify-content-center mb-4">
              <Pagination className="mb-2 mb-lg-0">
                <Pagination.Prev
                  onClick={() => setPage((prev) => Math.max(prev - 1, 1))}
                />
                {Array.from({ length: totalPages }, (_, index) => (
                  <Pagination.Item
                    key={index + 1}
                    active={index + 1 === page}
                    onClick={() => setPage(index + 1)}
                  >
                    {index + 1}
                  </Pagination.Item>
                ))}
                <Pagination.Next
                  onClick={() =>
                    setPage((prev) => Math.min(prev + 1, totalPages))
                  }
                />
              </Pagination>
            </Nav>
          </>
        )}
      </div>
    </>
  );
};
